const translation = {
  title: 'Обзор',
  sidebar: {
    discovery: 'Открытия',
    chat: 'Чат',
    workspace: 'Рабочее пространство',
    action: {
      pin: 'Закрепить',
      unpin: 'Открепить',
      rename: 'Переименовать',
      delete: 'Удалить',
    },
    delete: {
      title: 'Удалить приложение',
      content: 'Вы уверены, что хотите удалить это приложение?',
    },
  },
  apps: {
    title: 'Обзор приложений от Dify',
    description: 'Используйте эти шаблонные приложения мгновенно или настройте свои собственные приложения на основе шаблонов.',
    allCategories: 'Рекомендуемые',
  },
  appCard: {
    addToWorkspace: 'Добавить в рабочее пространство',
    customize: 'Настроить',
  },
  appCustomize: {
    title: 'Создать приложение из {{name}}',
    subTitle: 'Значок и название приложения',
    nameRequired: 'Название приложения обязательно',
  },
  category: {
    Assistant: 'Ассистент',
    Writing: 'Написание',
    Translate: 'Перевод',
    Programming: 'Программирование',
    HR: 'HR',
    Agent: 'Агент',
    Workflow: 'Рабочий процесс',
    Entertainment: 'Развлечение',
  },
}

export default translation
